import React from 'react'
import CustomDropdown from '../../CustomDropdown';
import Textarea from './Textarea';
import RedioText from './RedioText';
import InputText from './InputText';
import Checkbox from './Checkbox';

const FormField = ({ field, handleChange, formData, errors }) => {

    switch (field.type) {
        case "select": return (
            <CustomDropdown
                options={field.options}
                placeholder={field.placeholder}
                onSelect={handleChange}
                name={field.name}
                field={field}
            />);
        case "checkbox": return (
            <Checkbox
                field={field}
                handleChange={handleChange}
                formData={formData}
              
            />
        );
        case "textarea": return (
            <Textarea
                field={field}
                handleChange={handleChange}
                formData={formData}
                errors={errors}
                
            />
        );
        case "radio": return (
            <RedioText
                field={field}
                handleChange={handleChange}
            />
        );
        default: return (
            <InputText
                field={field}
                handleChange={handleChange}
                formData={formData}
                errors={errors}
               

            />
        );

    }

}
export default FormField;
